import AjaxCart from '../helpers/AjaxCart'

class ProductCardForm {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        this._elem.addEventListener('submit', e => { this.onSubmit(e) })
    }
    async onSubmit (e) {
        let notification = window.__Theme.getComponentByName('CartNotification')
        if (notification) {
            e.preventDefault()
            let payload = {
                id: parseInt(this._elem.id.value),
                quantity: 1
            }
            const button = this._elem.querySelector('[data-product-card-form-button]')
            if (button) {
                button.classList.add('waiting')
            }
            let response = await AjaxCart.addItem(payload)
            if (button) {
                button.classList.remove('waiting')
            }
            notification.open(response.product.data.product_title)
        } else {
            e.target.submit()
        }
    }
}

export default ProductCardForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductCardForm.js